// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7db7a86a","573":"085809c1"}[chunkId] + ".chunk.js";
};